export default {
  common: {
    patient: {
      sidebar: "Patient",
      header: "Patient Information",
      labels: {
        header: "Patient Information",
        first_name: "First Name",
        middle_name: "Middle Name",
        last_name: "Last Name",
        dob: "Birth Date",
        gender: "Gender",
        phone_number: "Phone Number",
        email: "Email Address",
        street_address: "Address",
        state: "State",
        city: "City",
        zip_code: "Zip Code",
        additional_phone_number: "Additional Phone Number",
        preferred_language: "Preferred Language",
        alternative_contact: "Add alternative contact"
      },
      placeholders: {
        first_name: "Enter First Name",
        middle_name: "Enter Middle Name",
        last_name: "Enter Last Name",
        phone_number: "Enter Phone Number",
        email: "Enter Email Address",
        street_address: "Enter Address",
        state: "Select State",
        city: "Enter City",
        zip_code: "Enter Zip Code",
        preferred_language: "Enter preferred Language",
        additional_phone_number: "Enter Phone Number"
      },
      female: "Female",
      male: "Male",
      prefer_no_answer: "Prefer not to answer"
    },
    insurance: {
      other: "Other",
      sidebar: "Insurance",
      medical_header: "Commercial Medical Insurance Information",
      pharmacy_header: "Commercial Pharmacy Insurance Information",
      labels: {
        header: "Insurance",
        is_insured: "Patient is Insured",
        primary_payer_name: "Primary Payer Name",
        secondary_payer_name: "Secondary Payer Name",
        subscriber_id: "Subscriber ID",
        group_number: "Group #",
        relation_to_patient: "Relation To Patient",
        subscriber_first_name: "Subscriber First Name",
        subscriber_last_name: "Subscriber Last Name",
        subscriber_date_of_birth: "Subscriber Date of Birth",
        payer_phone: "Payer Phone"
      },
      placeholders: {
        eligibility_reason: "Pick Eligibility Reason",
        denial_reason: "Enter Denial Reason",
        payer_name: "Enter Payer Name",
        subscriber_first_name: "Enter Subscriber First Name",
        subscriber_last_name: "Enter Subscriber Last Name",
        payer_phone: "Enter Payer Phone",
        uninsured_already_chosen:
          "In the 'Eligibility Reason' question of the questionnaire, the user indicated that the patient is uninsured",
        insured_already_chosen:
          "In the 'Eligibility Reason' question of the questionnaire, the user indicated that the patient is insured"
      }
    },
    practice: {
      labels: {
        prescriber_name: "Prescriber Name",
        prescriber_first_name: "Prescriber First Name",
        prescriber_last_name: "Prescriber Last Name",
        prescriber_npi: "Prescriber NPI",
        group_tax_id: "Tax ID"
      },
      placeholders: {
        prescriber_name: "Enter Prescriber Name",
        prescriber_first_name: "Enter First Name",
        prescriber_last_name: "Enter Last Name",
        npi: "Enter NPI",
        group_tax_id: "Enter Tax ID"
      }
    },
    medical: {
      labels: {
        primary_diagnosis: "Primary Diagnosis",
        secondary_diagnosis: "Secondary Diagnosis",
        tertiary_diagnosis: "Tertiary Diagnosis",
        quaternary_diagnosis: "Quaternary Diagnosis",
        add_diagnosis: "Add Diagnosis"
      },
      placeholders: {
        diagnosis: "Select Diagnosis name or ICD code"
      }
    },
    close_button: "Close",
    practice_npi_notification:
      "To connect your patient enrollment with the program portal, please input the practice NPI linked to your portal account.",
    header: "Enrollment Form Editor",
    description:
      "Verify the accuracy of prepopulated fields and complete all required fields that are missing information.",
    save_draft: "Save Draft"
  },
  pfizer: {
    free_drug: {},
    generate_button: "Generate PDF",
    save_and_generate_button: "Save & Generate PDF",
    financial: {
      header: "Financial Information",
      labels: {
        header: "Financial",
        total_number_of_people: "Total Number of People Within Household",
        total_annual_household_income: "Total Gross Annual Household Income",
        estimated_total_out_of_pocket: "Estimated OOP Medical Expenses (Yearly)"
      },
      placeholders: {
        total_number_of_people: "Enter Household Size",
        total_annual_household_income: "Enter Household Income",
        estimated_total_out_of_pocket: "Enter Estimated Out-of-Pocket Expenses"
      }
    },
    hcp: {
      other: "Other",
      labels: {
        provider_full_name: "Full Name",
        sidebar: "Prescriber",
        header: "Prescriber Information",
        provider_first_name: "First Name",
        provider_middle_name: "Middle Name",
        provider_last_name: "Last Name",
        payer_specific_number: "Payer Specific #",
        provider_npi: "NPI",
        provider_state_license: "State License",
        facility_name: "Practice / Institution Name",
        facility_street_address: "Street Address",
        facility_city: "City",
        facility_state: "State",
        facility_zip_code: "Zip Code",
        facility_contact_name: "Contact Name",
        facility_contact_phone: "Contact Phone",
        facility_contact_fax: "Assignee Fax",
        facility_contact_email: "Email",
        ship_to: "Ship To",
        patient_address: "Patient Address",
        prescriber_information_address: "Prescriber Information Address",
        other_address: "Other Address",
        shipment_address: "Shipment Street Address",
        shipment_city: "Shipment City",
        shipment_state: "Shipment State",
        shipment_zip_code: "Shipment Zip Code",
        shipment_facility_name: "Shipment Facility Name"
      },
      placeholders: {
        provider_first_name: "Enter First Name",
        provider_full_name: "Select Full Name",
        provider_middle_name: "Enter Middle Name",
        provider_last_name: "Enter Last Name",
        provider_npi: "Enter NPI",
        provider_state_license: "Enter State License",
        facility_id: "Select Practice / Institution Name",
        facility_name: "Enter Practice / Institution Name",
        facility_street_address: "Enter Street Address",
        facility_city: "Enter City",
        facility_state: "Select State",
        facility_zip_code: "Enter Zip Code",
        facility_contact_name: "Enter Contact Name",
        facility_contact_phone: "Enter Contact Phone",
        facility_contact_fax: "Enter Assignee Fax",
        facility_contact_email: "Enter Email",
        ship_to: "Enter Ship To",
        patient_address: "Enter Patient Address",
        other: "Enter other",
        shipment_address: "Enter Shipment Street Address",
        shipment_city: "Enter Shipment City",
        shipment_state: "Select Shipment State",
        shipment_zip_code: "Enter Shipment Zip Code",
        shipment_facility_name: "Enter Shipment Facility Name"
      },
      ineligible_answer_error: "If NO, Stop. This is required to be completed prior to requesting PAP enrollment."
    },
    insurance: {
      secondary_prescription_button: "+ Secondary Prescription Insurance Type",
      labels: {
        sidebar: "Insurance",
        header: "Insurance Information",
        medical_insurance_type: "Primary Medical Insurance Type",
        primary_insurance_type: "Primary Prescription Insurance Type",
        secondary_insurance_type: "Secondary Prescription Insurance Type",
        payer_name: "Payer Name",
        payer_phone: "Payer Phone",
        group_id: "Group ID",
        member_id: "Member ID",
        policyholder_same_as_patient: "Policyholder same as patient?",
        policyholder_full_name: "Policyholder Full Name",
        policyholder_relationship: "Policyholder Relationship",
        policyholder_dob: "Policyholder Date of Birth",
        covered_by_insurance:
          "Is your patient's Pfizer medication covered by either medical or prescription insurance?",
        copay_amount: "Copay Amount",
        prescription_payer_name: "Prescription Payer Name",
        prescription_bin: "Prescription BIN",
        phone_number: "Phone Number",
        prescription_pcn: "Prescription PCN",
        prescription_group_id: "Prescription Group ID",
        prescription_member_id: "Prescription Member ID",
        completed_bi:
          "Has your office or a pharmacy completed a Benefit Investigation/Pharmacy Claim for the requested product?",
        unaffordable_copay:
          "Does your patient understand their insured required copay and have they directly communicated that they are unable to afford this?",
        medicare_part_d_insurance_only: "Medicare Part D Insurance Only:",
        part_d_address: "Address",
        city: "City",
        state: "State",
        zip_code: "Zip Code",
        insurer_required_copayment: "Insurer required copayment (after Prior Authorization, if required)",
        out_of_pocket_for_prescriptions: "Out-of-pocket (OOP) maximum for prescriptions ",
        amount_met_towards_oop_max: "Amount met towards OOP max ",
        date_information_obtained_from_payer_or_spp: "Date Information obtained from Payer/SPP",
        payer_require_prior_authorization: "Does the payer require a Prior Authorization?",
        prior_authorization_number: "Prior Authorization Number",
        prior_authorization_dates: "Prior Authorization Dates"
      },
      placeholders: {
        state: "Select State",
        other: "Enter Insurance Type",
        city: "Enter City",
        zip_code: "Enter Zip Code",
        payer_name: "Enter Payer Name",
        payer_phone: "Enter Payer Phone",
        phone_number: "Enter Phone Number",
        group_id: "Enter Group ID",
        member_id: "Enter Member ID",
        policyholder_full_name: "Enter Policyholder Name",
        policyholder_relationship: "Enter Policyholder Relationship",
        policyholder_dob: "Select Date of Birth",
        prescription_payer_name: "Enter Prescription Payer Name",
        prescription_bin: "Enter Prescription BIN",
        prescription_pcn: "Enter Prescription PCN",
        prescription_group_id: "Enter Prescription Group ID",
        prescription_member_id: "Enter Prescription Member ID",
        part_d_address: "Enter Address",
        copay_amount: "Enter Amount",
        insurer_required_copayment: "Enter Insurer required copayment",
        out_of_pocket_for_prescriptions: "Enter Out-of-pocket",
        amount_met_towards_oop_max: "Enter Amount met towards OOP max",
        date_information_obtained_from_payer_or_spp: "Enter Date Information obtained from Payer/SPP",
        prior_authorization_number: "Enter Prior Authorization Number"
      },
      yes: "Yes",
      no: "No",
      commercial: "Commercial",
      medicare_part_d: "Medicare Part D",
      medicare_advantage: "Medicare Advantage",
      medicare_ab_only: "Medicare A/B only",
      medicaid: "Medicaid",
      va_benefits: "VA Benefits",
      other: "Other",
      none: "None"
    },
    patient: {
      labels: {
        sidebar: "Patient",
        header: "Patient Information",
        first_name: "First Name",
        last_name: "Last Name",
        middle_initial: "Middle Initial (MI)",
        dob: "Date of Birth",
        sex: "Sex",
        phone_number: "Phone Number",
        email: "Patient Email",
        street_address: "Street Address",
        state: "State",
        city: "City",
        zip_code: "Zip Code",
        primary_language: "Primary Language",
        contact_time: "Best time for manufacturer to contact the patient",
        caregiver_full_name: "Caregiver Full Name",
        caregiver_relationship: "Caregiver Relationship",
        caregiver_phone: "Caregiver Phone Number",
        reEnrollment: "Requesting re-enrollment in the PAP"
      },
      placeholders: {
        first_name: "Enter First Name",
        last_name: "Enter Last Name",
        middle_initial: "Enter Middle Initial",
        dob: "Enter Date of Birth",
        sex: "Enter Sex",
        phone_number: "Enter Phone Number",
        email: "Enter Patient Email",
        street_address: "Enter Street Address",
        state: "Select State",
        city: "Enter City",
        zip_code: "Enter Zip Code",
        primary_language: "Enter Primary Language",
        caregiver_full_name: "Enter Caregiver Full Name",
        caregiver_relationship: "Enter Caregiver Relationship",
        caregiver_phone: "Enter Phone Number"
      },
      morning: "Morning",
      afternoon: "Afternoon",
      evening: "Evening",
      female: "Female",
      male: "Male",
      other: "Other"
    },
    diagnosis: {
      labels: {
        header: "Diagnosis Information",
        sidebar: "Diagnosis",
        primary_diagnosis: "Primary Diagnosis Name",
        secondary_diagnosis: "Secondary Diagnosis Name"
      },
      placeholders: {
        diagnosis: "Select Diagnosis name or ICD code"
      },
      add_second_label: "Add Secondary Diagnosis"
    },
    prescription: {
      labels: {
        sidebar: "Prescription",
        header: "Prescription Information",
        drug_name: "Drug Name",
        tablet_strength: "1 Tablet Strength",
        quantity: "Quantity (1 Refill)",
        refills: "Number of Refills",
        vial_strength: "Vial Strength",
        vial_size: "Vial Size",
        day_supply: "Day Supply",
        dosing_instructions: "Directions/Dosing Instructions",
        concomitant_meds: "Concomitant Medications (Other Prescribed Medications)",
        allergies: "Drug Allergies",
        allergy_details: "Please list medication[s] and associated reaction[s]",
        directions: "Directions",
        number_of_vials: "Number of Vials (1 cycle)",
        frequency: "Frequency of Treatment",
        treatment_start_date: "Treatment Start Date"
      },
      placeholders: {
        drug_name: "Select Drug Name",
        tablet_strength: "Enter Tablet Strength",
        quantity: "Enter Quantity",
        refills: "Enter Number of Refills",
        vial_strength: "Select Vial Strength",
        vial_size: "Enter Vial Size",
        dosing_instructions: "Enter Directions/Dosing Instructions",
        concomitant_meds: "Enter Concomitant Medications (Other Prescribed Medications)",
        allergy_details: "Enter medication[s] and associated reaction[s]",
        directions: "Enter Directions",
        number_of_vials: "Enter Number of Vials",
        frequency: "Enter Frequency of Treatment",
        treatment_start_date: "Select Treatment Start Date"
      },
      yes: "Yes",
      no: "No",
      mg: "mg",
      information_notice:
        "A valid prescription must be received before a determination of assistance can be made as this is a requirement for program enrollment.",
      hover_for_details: "(see more details on hover)"
    },
    errors: {
      number_incorrect_fields: "Incorrect field, fill in only numbers",
      no_numbers_incorrect_fields: "Incorrect field, no numbers allowed",
      required_field: "Required Field",
      invalid_email: "Invalid Email"
    },
    attachments: {
      labels: {
        header: "Attachments"
      },
      first_details: "Please upload all required attachments",
      second_details: "to the application attachments section"
    },
    rules: {
      required_field: "Required field"
    },
    copay: {
      iv: {
        patient: {
          sidebar: "Patient",
          labels: {
            header: "Patient Information",
            gender: "Gender",
            phone: "Phone",
            email: "Email",
            first_name: "First Name",
            last_name: "Last Name",
            dob: "Date of Birth",
            street_address: "Street Address",
            city: "City",
            state: "State",
            zip_code: "Zip Code"
          },
          placeholders: {
            first_name: "Enter First Name",
            last_name: "Enter Last Name",
            phone: "Enter Phone",
            street_address: "Enter Address",
            state: "Select State",
            city: "Enter City",
            zip_code: "Enter Zip Code",
            email: "name@gmail.com"
          },
          gender_other: "Other"
        },
        practice: {
          sidebar: "Practice",
          labels: {
            header: "Practice Information",
            npi: "Practice NPI Number"
          },
          placeholder: {
            npi: "Enter NPI #"
          }
        },
        consent: {
          sidebar: "Consent",
          header: "Consents and Attestations",
          ineligible_answer_error:
            "YES is required to proceed. If you need further assistance, please call {{phone_number}}",
          ineligible_checkbox_answer_error:
            "You are required to check the box to proceed. If you need further assistance, please call {{phone_number}}"
        }
      },
      oral: {
        patient: {
          sidebar: "Patient",
          labels: {
            header: "Patient Information",
            first_name: "First Name",
            last_name: "Last Name",
            birth_date: "Birth date",
            sex: "Sex",
            address: "Address",
            city: "City",
            state: "State",
            zip_code: "ZIP Code",
            email: "Email",
            phone_number: "Phone Number",
            caregiver: "Caregiver"
          },
          placeholders: {
            first_name: "Enter First Name",
            last_name: "Enter Last Name",
            phone_number: "Enter Phone Number",
            email: "Enter Email Address",
            address: "Enter Address",
            state: "Select State",
            city: "Enter City",
            zip_code: "Enter Zip Code"
          }
        },
        consent: {
          sidebar: "Consent",
          labels: {
            header: "Consent Information",
            program_eligibility_criteria_text_header: `<bold>Program Eligibility Criteria*</bold><br><br>Please verify the following information for the patient to receive a co-pay savings card:<br><br>`,
            program_eligibility_criteria_text_above_18: `• The patient is 18 years of age or older.<br>`,
            program_eligibility_criteria_text: `• The patient currently lives in the United States or Puerto Rico.<br>• The patient does not have insurance from any federal healthcare program (including Medicare, Medicaid, TRICARE, or any other state or federal medical pharmaceutical benefit program or pharmaceutical assistance program).<br>• The patient is not over 65 years of age and retired, and if applicable, neither is their partner.<br>• The patient does not receive Social Security Disability or any other Social Security Administration benefit.<br>• The patient does not receive health insurance through the military.<br>• The patient has reviewed and agreed to the Terms and Conditions and is eligible to participate in this program.<br>• You are not licensed to practice medicine in the state of Vermont.`,
            program_eligibility_criteria:
              "I attest based on the information provided to me by the patient that the patient meets the above eligibility requirements for the program.",
            privacy_authorization_text: `<bold>Privacy Authorization*</bold>`,
            privacy_authorization:
              "By checking this box, the patient agrees to share their contact information and certain health information with Pfizer and Pfizer's service providers and grant permission for those entities to send the patient helpful information regarding Pfizer's products, treatments, and offers. Pfizer values the patient’s privacy; this personal information will be handled in accordance with Pfizer’s Privacy Policy. The patient can unsubscribe from these communications at any time by clicking “Unsubscribe” in the communications they receive. Privacy Statement for Co-Pay Savings Program: Pfizer understands that the patient’s personal and health information is private and will only use the patient information in accordance with our Privacy Policy. The information the patient provides will only be used by Pfizer and parties acting on its behalf to send the patient the materials they requested, as well as other helpful product and/or related product information, disease state information, offers, and services.",
            marketing_communication_text: `<bold>Marketing Communication</bold>`,
            marketing_communication:
              "By checking this box, the patient agrees to receive communications from Pfizer Oncology Together, a support program that offers financial assistance and personalized resources for patients prescribed Pfizer Oncology medicines."
          },
          errors: {
            program_eligibility_criteria: "Should accept eligibility criteria",
            privacy_authorization: "Should accept privacy authorization"
          }
        }
      }
    }
  },
  genentech: {
    copay: {
      submit_button: "Submit Application",
      support_options: {
        header: "Support Options",
        title: "Please select the types(s) of assistance you are applying for:",
        checkbox_drug: "Apply for help with {{drug}} drug out-of-pocket costs.",
        checkbox_admin: "Apply for help with {{drug}} administration out-of-pocket costs.",
        sidebar: "Support Options",
        state_ineligibility_message:
          "Administration assistance is not available for residents of Massachusetts or Rhode Island.",
        state_mismatch_warning:
          "The state selected in the questionnaire and patient information sections do not match. Please ensure both fields have the same state."
      },
      eligibility_questionnaire: {
        sidebar: "Eligibility Questionnaire",
        header: "Eligibility Questionnaire",
        ineligible_answer_error:
          "The chosen selection does not meet the eligibility criteria for enrollment submission."
      },
      patient: {
        sidebar: "Patient",
        header: "Patient Information",
        labels: {
          first_name: "First Name",
          middle_name: "Middle Name",
          last_name: "Last Name",
          dob: "Birth Date",
          gender: "Gender",
          phone_number: "Phone Number",
          email: "Email Address",
          street_address: "Address",
          state: "State",
          city: "City",
          zip_code: "Zip Code"
        },
        placeholders: {
          first_name: "Enter First Name",
          middle_name: "Enter Middle Name",
          last_name: "Enter Last Name",
          phone_number: "Enter Phone Number",
          email: "Enter Email Address",
          street_address: "Enter Address",
          state: "Select State",
          city: "Enter City",
          zip_code: "Enter Zip Code"
        },
        female: "Female",
        male: "Male",
        prefer_no_answer: "Prefer not to answer"
      },
      insurance: {
        other: "Other",
        sidebar: "Insurance",
        medical_header: "Commercial Medical Insurance Information",
        pharmacy_header: "Commercial Pharmacy Insurance Information",
        labels: {
          insurance_medical_group_id: "Insurance Group Number",
          insurance_medical_Member_id: "Insurance Member Number",
          insurance_medical_name: "Insurance Company Name",
          insurance_medical_plan_type: "Insurance Plan Type",
          insurance_medical_insurance_effective_date: "Insurance Effective Date",
          insurance_medical_without_bin_and_pcn: "Insurance card does not have BIN and PCN",
          insurance_medical_rx_bin: "BIN",
          insurance_medical_rx_pcn: "PCN",
          insurance_without_pharmacy_insurance_card: "Does not have a pharmacy insurance card",
          insurance_pharmacy_group_id: "Rx Group Number",
          insurance_pharmacy_member_id: "Rx Member Number",
          insurance_pharmacy_name: "Rx Company Name",
          insurance_pharmacy_rx_bin: "Rx BIN",
          insurance_pharmacy_rx_pcn: "Rx PCN"
        },
        placeholders: {
          insurance_medical_group_id: "Enter Insurance Group Number",
          insurance_medical_Member_id: "Enter Insurance Member Number",
          insurance_medical_select_name: "Select Insurance Company Name",
          insurance_medical_name: "Enter Insurance Company Name",
          insurance_medical_plan_type: "Select Insurance Plan Type",
          insurance_medical_other_plan_type: "Enter Insurance Plan Type",
          insurance_medical_insurance_effective_date: "Select Insurance Effective Date",
          insurance_medical_rx_bin: "Enter BIN",
          insurance_medical_rx_pcn: "Enter PCN",
          insurance_pharmacy_group_id: "Enter Rx Group Number",
          insurance_pharmacy_member_id: "Enter Rx Member Number",
          insurance_pharmacy_name: "Enter Rx Company Name",
          insurance_pharmacy_rx_bin: "Enter Rx BIN",
          insurance_pharmacy_rx_pcn: "Enter Rx PCN"
        }
      },
      physician_and_facility: {
        sidebar: "Physician & Facility",
        doctor_header: "Doctor information",
        facility_header: "Treating facility information",
        other: "Other",
        labels: {
          physician_full_name: "Full Name",
          physician_first_name: "First Name",
          physician_last_name: "Last Name",
          physician_practice_name: "Practice Name",
          physician_address: "Address",
          physician_city: "City",
          physician_state: "State",
          physician_zip: "Zip Code",
          physician_phone: "Phone Number",
          physician_npi: "National Provider Identifier (NPI)",
          facility_name: "Treating facility",
          facility_address: "Address",
          facility_city: "City",
          facility_state: "State",
          facility_zip: "Zip Code",
          facility_phone: "Phone Number",
          facility_npi: "National Provider Identifier (NPI)"
        },

        placeholders: {
          physician_full_name: "Select Full Name",
          physician_first_name: "Enter First Name",
          physician_last_name: "Enter Last Name",
          physician_practice_name: "Enter Practice Name",
          physician_address: "Enter Address",
          physician_city: "Enter City",
          physician_state: "Select State",
          physician_zip: "Enter Zip Code",
          physician_phone: "Enter Phone Number",
          physician_npi: "Enter National Provider Identifier (NPI)",
          facility_select_name: "Select Treating facility",
          facility_name: "Enter Treating facility",
          facility_address: "Enter Address",
          facility_city: "Enter City",
          facility_state: "Select State",
          facility_zip: "Enter Zip Code",
          facility_phone: "Enter Phone Number",
          facility_npi: "Enter National Provider Identifier (NPI)"
        }
      },
      warnings: {
        name_matches_insurance_or_id: "Please verify that the name matches the patient's insurance/ID"
      }
    },
    free_drug: {
      submit_button: "Submit Application",
      support_options: {
        header: "Support Options",
        title: "Please select the types(s) of assistance you are applying for:",
        checkbox_drug: "Apply for help with {{drug}} drug out-of-pocket costs.",
        checkbox_admin: "Apply for help with {{drug}} administration out-of-pocket costs.",
        sidebar: "Support Options",
        state_ineligibility_message:
          "Administration assistance is not available for residents of Massachusetts or Rhode Island.",
        state_mismatch_warning:
          "The state selected in the questionnaire and patient information sections do not match. Please ensure both fields have the same state."
      },
      eligibilityQuestionnaire: {
        sidebar: "Eligibility Questionnaire",
        header: "Eligibility Questionnaire",
        ineligible_answer_error:
          "The chosen selection does not meet the eligibility criteria for enrollment submission.",
        questionnaire_differentiation_question: "Please choose the drug you want to apply to"
      },
      patient: {
        sidebar: "Patient",
        header: "Patient Information",
        labels: {
          header: "Patient Information",
          first_name: "First Name",
          middle_name: "Middle Name",
          last_name: "Last Name",
          dob: "Birth Date",
          gender: "Gender",
          phone_number: "Phone Number",
          email: "Email Address",
          street_address: "Address",
          state: "State",
          city: "City",
          zip_code: "Zip Code",
          additional_phone_number: "Additional Phone Number",
          preferred_language: "Preferred Language",
          alternative_contact: "Add alternative contact",
          relation_to_patient: "Relationship to patient",
          alternative_patient_info: "Alternative Contact Information",
          divider: "Legal Authorized Person (LAP) Information",
          signed_patient_authorization: "Signed Patient Authorization"
        },
        placeholders: {
          first_name: "Enter First Name",
          middle_name: "Enter Middle Name",
          last_name: "Enter Last Name",
          phone_number: "Enter Phone Number",
          email: "Enter Email Address",
          street_address: "Enter Address",
          state: "Select State",
          city: "Enter City",
          zip_code: "Enter Zip Code",
          preferred_language: "Enter preferred Language",
          additional_phone_number: "Enter Phone Number",
          relation_to_patient: "Select Relationship"
        },
        female: "Female",
        male: "Male",
        prefer_no_answer: "Prefer not to answer"
      },
      consent: {
        sidebar: "Patient Consent"
      },
      patient_consent: {
        sidebar: "Patient Consent",
        labels: {
          header: "Patient Consent",
          personal_info_consent:
            "By checking this box and submitting the completed form, I acknowledge that I have provided accurate and complete information and understand and agree to the terms of this form.  I have read, understood, and agree to the release and use of my personal information, including sensitive personal information, pursuant to the Authorization to Use and Disclose Personal Information and as otherwise stated on this form.",
          authorization_required_text:
            "<bold>AUTHORIZATION TO USE AND DISCLOSE PERSONAL INFORMATION</bold><br><br>I authorize my physician(s) and their staff, pharmacies, and health insurance plan (my “health care providers”) to share my personal information, which may include contact information, demographic information, financial information, and information related to my medical condition, treatments, and health insurance and benefits, with Genentech, Genentech Patient Foundation, and their respective partners, affiliates, subcontractors, and agents (together, “Genentech”). I authorize Genentech to receive, use, and share my personal information in order to provide me with access to the products, services, and programs described on this form, which may include the following:<br>• Working with my health insurance plan to understand or verify coverage for Genentech products<br>• Applying to the Genentech Patient Foundation<br>• Determining my eligibility for and facilitating enrollment into financial assistance services if I'm eligible, including co‐pay assistance<br>• Coordinating my prescription through a pharmacy, infusion site and/or health care provider's office. This includes contacting me to discuss my coverage, costs and eligibility for assistance and other program administration purposes<br>• Facilitating my access to Genentech products<br>• Ensuring quality and safety and improving our products and services<br>• Contacting me by mail, e-mail, telephone calls and text messages at the number(s) and address(es) provided for non-marketing purposes<br>• If I agree to the <bold>optional</bold> Consent for Patient Resources and Information, providing me with optional disease information and marketing material about products, services and programs offered by Genentech, its partners and their respective affiliates. This is not required to enroll into Genentech Access Solutions services<br>• If I agree to the <bold>optional</bold> Telephone Consumer Protection Act (TCPA) Consent, contacting me by autodialed calls and/or text messages at the phone number(s) I have provided for marketing purposes. This is not required to enroll into Genentech Access Solutions services<br><br>I understand that this will include sharing and use of information about me that could be considered sensitive personal information, such as health conditions, but that the use of this information by Genentech is necessary to determine if I qualify for and to administer the benefits and services for which I am applying. I understand that Genentech may also share my personal information, including sensitive personal information, for the purposes described on this authorization with my health care providers, service providers, and any individual I may designate as an alternate contact. I understand that my pharmacy may receive payment or other remuneration for disclosing my personal information pursuant to this authorization. I can choose not to sign this authorization, but Genentech will not be able to provide the services to me without it. However, my health care providers may not condition either my treatment or my payment, enrollment, or eligibility for benefits on signing this authorization. I also understand and agree that:• This authorization is valid for 6 years from the date I sign or the date I last enrolled, whichever comes first, unless a shorter period is required by law, or I revoke it earlier<br>• My personal information released under this authorization may no longer be protected by state and federal law, including the Health Insurance Portability and Accountability Act (HIPAA). However, Genentech will only use and share my personal information for the purposes stated on this authorization or as otherwise permitted by law <br>• I have the right to revoke (cancel) this authorization at any time by submitting a written notice to: Genentech Access Solutions, 1 DNA Way, South San Francisco, CA 94080-4990 or by calling <bold>(866) 422-2377</bold>. If I revoke this authorization, I will no longer be eligible for the services described. If a health care provider is disclosing my personal information to Genentech on an authorized, ongoing basis, my revocation will be effective with respect to such health care provider when they receive notice of my revocation. My revocation will not impact uses and disclosures of my personal information that have already occurred in reliance on this authorization<br>• More information on my privacy rights, including specific rights I may have as a resident of certain states, can be found in Genentech's privacy policy (<bold><a_privacy>www.gene.com/privacy-policy</a_privacy></bold>)<br>• I have a right to receive a copy of this authorization",
          authorization_required_divider: "Authorization Required",
          patient_resources_consent_divider: "Consent for Patient Resources and Information (Optional)",
          patient_resources_consent:
            "By checking this box, I agree to receive optional disease education and other material. I understand providing this agreement is voluntary and plays no role in getting Genentech Access Solutions services or my medicine and that it may be necessary to use my sensitive personal information to provide me with relevant material. I also understand that I may opt out of receiving this information at any time by calling (877) 436-3683 and that this consent will remain active unless I opt out.",
          patient_resources_consent_evrysdi:
            "       By checking this box, I agree to receive disease education materials and product support services, including outreach by a PAL. I understand that I don't have to opt into this offer and my decision does not affect receiving my medicine or financial support information. It may be necessary to use my sensitive personal information to provide me with relevant material. I also understand that I may opt out of receiving this information at any time by calling (877) 436-3683.",
          patient_resources_consent_text:
            "Genentech offers <bold>optional</bold> and free disease education and other material for patients. This may include information and marketing material about products, services and programs offered by Genentech, its partners and their respective affiliates. If you sign up, you may be contacted using the information you have provided.",
          patient_resources_consent_text_evrysdi:
            "Genentech offers disease education and product support for patients, including items or marketing materials explaining the product and how to take it, use when traveling with the product and other information about Genentech products, services and programs. You do not have to sign up for these resources and support to get help with your insurance coverage or to learn about financial assistance options. Signing up here allows you to be contacted using the information you provide on this form. These marketing materials and support are optional, free and may be provided by a PAL, Genentech's partners and their respective affiliates. PALs do not provide medical advice. Your healthcare provider should always be your main resource for any questions about your health and medical care.",
          patient_resources_consent_text_below:
            "By checking this box, I agree to receive autodialed calls and text messages, which may include marketing communications about Evrysdi from and on behalf of Genentech, including from a PAL, at the phone number(s) provided. I understand that choosing to receive these messages is voluntary and is not a requirement of any purchase or program enrollment. Message frequency may vary. Message and data rates may apply. I may opt out at any time by texting STOP or calling <bold>(877) GENENTECH</bold>/(877) 436-3683. I am also agreeing to the <bold>Privacy Policy</bold> (<bold><a_privacy>www.gene.com/privacy-policy</a_privacy></bold>) and <bold>SMS Terms & Conditions</bold> (<bold><a_terms_conditions>www.gene.com/terms-conditions/sms-text-message-program-terms-conditions</a_terms_conditions></bold>).",
          signer_relationship: "Relationship to Patient",
          signer_name: "First Name",
          signer_last_name: "Last Name",
          signer_email: "Email"
        },
        errors: {
          personal_info_consent: "Should accept Authorization terms"
        },
        placeholders: {
          signer_relationship: "Select Relationship to Patient",
          signer_email: "Enter Email Address"
        }
      },
      prescription: {
        sidebar: "Prescription",
        labels: {
          header: "Prescription",
          product: "Product",
          prescription_type: "Prescription Type",
          prescription_type_placeholder: "Select prescription type",
          prescription_option: "Prescription Option",
          prescription_option_placeholder: "Select option",
          dosage: "Dosage",
          dosage_unit: "Dosage Unit",
          dispense_quantity: "Dispense Quantity",
          dispense_unit: "Dispense Unit",
          frequency_of_administration_timing: "Frequency of Administration",
          frequency: "Frequency of Administration",
          refills: "Refills",
          supply_duration: "Supply Duration (Unit)",
          supply_duration_value: "Supply Duration (Value)",
          sig: "SIG",
          information_replacement_shipment: "No Prescription required for Replacement Shipment",
          information_notice:
            "PLEASE NOTE: An eSigned Prescriber Foundation Form cannot be used as a prescription for upfront shipments. To submit a valid prescription you can: \nProvide a verbal prescription to our specialty pharmacy by calling (833) 888-4363 \nFax a prescription with a “wet” signature to (833) 999-4363 \nSubmit an ePrescription to: MedVantx (AmeriPharm), NCPDP/NABP: 4351968, NPI: 1073692745 \nIf you have questions please contact Access Solutions at (866) 422-2377."
        }
      },
      medical: {
        sidebar: "Medical",
        labels: { header: "Medical" }
      },
      practice: {
        sidebar: "Practice",
        other: "Other",
        labels: {
          header: "Prescriber",
          facility_name: "Practice Name",
          address: "Address",
          city: "City",
          state: "State",
          zip: "Zip",
          facility_npi: "Practice NPI",
          facility_tax_id: "Tax ID",
          contact_first_name: "Contact First Name",
          contact_last_name: "Contact Last Name",
          contact_phone: "Contact Phone",
          contact_fax: "Contact Fax",
          practice_divider: "Practice",
          office_contact_first_name: "Contact First Name",
          office_contact_last_name: "Contact Last Name",
          office_contact_phone: "Phone Number",
          office_contact_fax: "Fax",
          office_contact_divider: "Office Contact",
          treatment_site_name: "Name",
          treatment_site_address: "Address",
          treatment_site_city: "City",
          treatment_site_state: "State",
          treatment_site_npi: "NPI",
          treatment_site_zip: "Zip Code",
          treatment_site_tax_id: "Tax ID",
          treatment_site_contact_name: "Contact Name",
          treatment_site_contact_phone: "Phone Number",
          treatment_site_contact_fax: "Fax",
          treatment_site_contact_email: "Email",
          practice_info_divider: "Site of treatment"
        },
        placeholders: {
          facility_name: "Select Practice Name",
          facility_input: "Enter Practice Name",
          address: "Enter Address",
          city: "Enter City",
          state: "Select State",
          zip: "Enter Zip",
          facility_npi: "Enter NPI",
          facility_tax_id: "Enter Tax ID",
          contact_first_name: "Enter Contact First Name",
          contact_last_name: "Enter Contact Last Name",
          contact_phone: "Enter Phone Number",
          contact_fax: "Enter Fax Number",
          office_contact_first_name: "Enter Contact First Name",
          office_contact_last_name: "Enter Contact Last Name",
          office_contact_phone: "Enter Phone Number",
          office_contact_fax: "Enter Fax Number",
          treatment_site_name: "Enter Name",
          treatment_site_address: "Enter Address",
          treatment_site_city: "Enter City",
          treatment_site_state: "Select State",
          treatment_site_npi: "Enter NPI",
          treatment_site_zip: "Enter Zip Code",
          treatment_site_tax_id: "Enter Tax ID",
          treatment_site_contact_name: "Enter Contact Name",
          treatment_site_contact_phone: "Enter Phone Number",
          treatment_site_contact_fax: "Enter Fax Number",
          treatment_site_contact_email: "Enter Email"
        }
      },
      submitAttestation: {
        sidebar: "Submit attestation"
      },
      submit_attestation: {
        sidebar: "Submit attestation",
        labels: {
          header: "Submit attestation",
          hipaa_auth_consent: "I have read and understand the information above.",
          hipaa_auth_consent_text: `<bold>By signing below, I am agreeing to the following:</bold> (A) The Genentech medicine listed above is medically necessary for this patient. (B) I have received authorization to release the information above and other protected health information (as defined by HIPAA) to the Genentech Patient Foundation and its affiliates. (C) I will not seek reimbursement for free product provided to the patient. (D) My patient meets the criteria for the Genentech Patient Foundation and to the best of my knowledge, this patient has no prescription insurance coverage (including Medicaid, Medicare, or other public or private programs) for the Genentech medicine listed above, or is unable to afford the cost-sharing requirements associated with his/her/their insurance coveragefor this medication. If the patient is enrolled in an insurance plan, the plan does not require the patient’s application to the Genentech Patient Foundation and/or has not changed or hidden the patient’s coverage for the Genentech medicine to make them appear to be underinsured and eligible for the Genentech Patient Foundation. (E) I understand that Genentech reserves the right to modify or discontinue the program at any time and to verify the accuracy of information submitted. (F) If the indication for which you are prescribing a Genentech product is not listed in the FDAapproved label, you are prescribing the medicine for an “unapproved” use, meaning that the FDA has not approved the efficacy, dosage amount or safety of this medicine when used for such ause. The Genentech Patient Foundation may provide the medicine for your patient, based upon your medical order and within program requirements. (G) For insured patients, I understand that the Genentech Patient Foundation does not provide free drug in the instance of an administrative error or a coverage restriction such as a step edit. For certain products where the step edit may not be medically appropriate, as confirmed by the prescribing physician, the Genentech Patient Foundation may consider support following 1 level of appeal. (H) For prescribers in states with electronic prescription requirements, such as New York, prescriptions must be submitted via e-prescription directly to the pharmacy along with this enrollment form.`
        },
        errors: {
          hipaa_auth_consent: "Should accept attestation"
        }
      },
      insurance: {
        primary_insurance: "Primary Insurance",
        add_secondary_insurance: "Add Secondary Insurance",
        delete_secondary_insurance: "Delete Secondary Insurance",
        other: "Other",
        sidebar: "Insurance",
        medical_header: "Commercial Medical Insurance Information",
        pharmacy_header: "Commercial Pharmacy Insurance Information",
        labels: {
          header: "Insurance",
          insurance_status: "Patient is Insured",
          eligibility_reason: "Eligibility Reason",
          denial_reason: "Denial Reason",
          denial_reason_date: "Denial Reason Date",
          primary_payer_name: "Primary Payer Name",
          secondary_payer_name: "Secondary Payer Name",
          primary_subscriber_id: "Primary Subscriber ID",
          secondary_subscriber_id: "Secondary Subscriber ID",
          group_number: "Group #",
          relation_to_patient: "Relation To Patient",
          subscriber_first_name: "Subscriber First Name",
          subscriber_last_name: "Subscriber Last Name",
          subscriber_date_of_birth: "Subscriber Date of Birth",
          payer_phone: "Payer Phone",
          prescription_plan: "Is This Is A Prescription Plan?"
        },
        placeholders: {
          eligibility_reason: "Pick Eligibility Reason",
          denial_reason: "Enter Denial Reason",
          payer_name: "Enter Payer Name",
          subscriber_first_name: "Enter Subscriber First Name",
          subscriber_last_name: "Enter Subscriber Last Name",
          payer_phone: "Enter Payer Phone",
          relation_to_patient: "Select Relation To Patient",
          subscriber_id: "Enter Subscriber ID",
          group_number: "Enter Group Number"
        }
      },
      physician_and_facility: {}
    }
  },
  novartis: {
    copay: {
      submit_button: "Submit Application",
      support_options: {
        header: "Support Options",
        sidebar: "Support Options"
      },
      patient: {
        sidebar: "Patient",
        header: "Patient Information",
        labels: {
          header: "Patient Information",
          sidebar: "Patient Information",
          gender: {
            header: "Sex for Clinical Use",
            option_3: "Prefer not to say",
            option_4: "Gender nonconforming"
          },
          biological_medication:
            "Has the patient ever been prescribed a biologic (injection or infusion) medication before?",
          caregiver_divider: "Caregiver Information"
        }
      },
      eligibilityAndAttestation: {
        sidebar: "Eligibility and Attestation",
        labels: {
          header: "Eligibility and Attestation",
          cosentyx_consent:
            "I have discussed the Novartis Co-Pay program with my patient, who has authorized me under HIPAA and state law to disclose their information to IQVIA for the limited purpose of enrolling in Novartis Patient Support.  To complete this enrollment, TailorMed will reach out to the patient by text and email.",
          hipaa_auth_consent_text:
            "I have discussed the Novartis Co-Pay Program with my patient, who has authorized me under HIPAA and state law to disclose their information to IQVIA for the limited purpose of enrolling in Novartis Patient Support. To complete this enrollment, TailorMed will reach out to the patient by text and email.",
          hipaa_auth_consent_error: "Should accept HIPAA Authorization"
        }
      },
      condition: {
        sidebar: "Condition",
        labels: { header: "Condition", condition: "What is the patient’s primary condition being treated?" }
      },
      supportOptions: {
        sidebar: "Support Options",
        labels: {
          header: "Support Options",
          support_option: "Please select the type of assistance you are applying for your patient:"
        }
      }
    }
  },
  eagle: {
    header: "Enrollment Form Editor",
    description:
      "Verify the accuracy of prepopulated fields and complete all required fields that are missing information.",
    complete_button: "Complete Form",
    patient: {
      labels: {
        sidebar: "Patient",
        header: "Patient Information",
        first_name: "First Name",
        last_name: "Last Name",
        middle_initial: "Middle Initial",
        dob: "Date of Birth",
        gender: "Gender",
        primary_phone_number: "Primary Phone Number",
        secondary_phone_number: "Secondary Phone Number",
        email: "Email",
        address: "Address",
        state: "State",
        city: "City",
        zip_code: "Zip Code",
        us_citizen: "US Citizen",
        alternate_contact_name: "Alternate Contact Name",
        relationship: "Relationship",
        phone_number: "Phone Number"
      },
      placeholders: {
        first_name: "Enter First Name",
        last_name: "Enter Last Name",
        middle_initial: "Enter Middle Initial",
        dob: "Enter Date of Birth",
        primary_phone_number: "Enter Primary Phone Number",
        secondary_phone_number: "Enter Secondary Phone Number",
        email: "Enter Patient Email",
        address: "Enter Address",
        state: "Select State",
        city: "Enter City",
        zip_code: "Enter Zip Code",
        alternate_contact_name: "Enter Alternate Contact Name",
        contact_patient_for_additional_information: "Okay to Contact Patient for Additional Information?",
        relationship: "Enter Relationship",
        phone_number: "Enter Phone Number"
      },
      female: "Female",
      male: "Male",
      other: "Other",
      yes: "Yes",
      no: "No"
    },
    insurance: {
      labels: {
        sidebar: "Insurance",
        header: "Insurance Information",
        not_have_insurance: "Check if patient does not have insurance",
        secondary_insurance: "Check if patient has secondary insurance ",
        commercial_plan: "HSA commercial plan",
        flexible_spending_account_participant: "Flexible Spending Account participant",
        primary_insurance_name: "Primary Insurance Name",
        primary_insurance_phone: "Insurance Phone Number",
        secondary_insurance_name: "Secondary Insurance Name",
        secondary_insurance_phone: "Secondary Insurance Phone Number",
        policy_number: "Policy Number",
        group_number: "Group Number",
        policyholder_name: "Policyholder Name",
        relationship_to_patient: "Relationship to Patient",
        check_any_that_apply: "Check any that apply"
      },
      placeholders: {
        secondary_insurance_name: "Enter Secondary Insurance Name",
        secondary_insurance_phone: "Enter Secondary Insurance Phone Number",
        primary_insurance_name: "Enter Primary Insurance Name",
        primary_insurance_phone: "Enter Primary Insurance Phone Number",
        policy_number: "Enter Policy Number",
        group_number: "Enter Group Number",
        policyholder_name: "Enter Policyholder Name",
        relationship_to_patient: "Enter Relationship to Patient"
      },
      yes: "Yes",
      no: "No",
      insurance_pharmacy_card: "Insurance & pharmacy card attached",
      medicare_part_a: "Medicare part A participant EFF. Date",
      medicare_part_b: "Medicare part B participant EFF. Date",
      medicare_pending: "Medicare application pending",
      medicaid_eff: "Medicaid participant EFF. Date",
      medicaid_pending: "Medicaid application pending",
      champus_eff: "Champus EFF. Date",
      va_insurance_eff: "VA insurance benefits participant EFF. Date",
      va_insurance_pending: "VA insurance benefit application pending"
    },
    provider: {
      other: "Other",
      labels: {
        sidebar: "Provider",
        header: "Provider Information",
        provider_full_name: "Full Name",
        tax_id: "Tax ID Number",
        group_npi: "Group NPI Number",
        provider_npi: "Provider NPI Number",
        florida_blue_id: "Florida Blue ID Number",
        medicare_ptan: "Medicare Provider Transaction Access Number (PTAN)",
        provider_first_name: "First Name",
        provider_last_name: "Last Name"
      },
      placeholders: {
        provider_full_name: "Select Full Name",
        tax_id: "Enter Tax ID Number",
        group_npi: "Enter Group NPI Number",
        provider_npi: "Enter Provider NPI Number",
        florida_blue_id: "Enter Florida Blue ID Number",
        medicare_ptan: "Enter Medicare Provider Transaction Access Number (PTAN)",
        provider_first_name: "Enter First Name",
        provider_last_name: "Enter Last Name"
      }
    },
    practice: {
      labels: {
        sidebar: "Practice",
        header: "Practice Information",
        practice_name: "Practice Name",
        practice_contact: "Practice Contact Name",
        address: "Address",
        state: "State",
        city: "City",
        zip_code: "Zip Code",
        practice_phone: "Practice Phone Number",
        practice_fax: "Practice Fax Number",
        email: "Contact Email"
      },
      placeholders: {
        practice_name: "Select Practice Name",
        practice_contact: "Enter Practice Contact Name",
        address: "Enter Address",
        state: "Select State",
        city: "Enter City",
        zip_code: "Enter Zip Code",
        practice_phone: "Enter Practice Phone Number",
        practice_fax: "Enter Practice Fax Number",
        email: "Enter Contact Email"
      },
      yes: "Yes",
      no: "No",
      other: "Other"
    },
    clinical: {
      labels: {
        header: "Clinical Information",
        sidebar: "Clinical",
        primary_diagnosis: "Primary Diagnosis Name",
        secondary_diagnosis: "Secondary Diagnosis Name",
        product_ndc: "Product NDC",
        treatment_fda: "Treatment FDA approved",
        previous_therapies: "Previous Therapies",
        concurrent_therapies: "Concurrent Therapies",
        site_of_care: "Site of Care"
      },
      placeholders: {
        diagnosis: "Select Diagnosis name or ICD code",
        product_ndc: "Enter Product NDC",
        previous_therapies: "Enter Previous Therapies",
        concurrent_therapies: " Enter Concurrent Therapies"
      },
      add_second_label: "Add Secondary Diagnosis",
      yes: "Yes",
      no: "No",
      physicians_office: "Physicians Office",
      hospital_outpatient: "Hospital Outpatient",
      other: "Other"
    },

    errors: {
      number_incorrect_fields: "Incorrect field, fill in only numbers",
      no_numbers_incorrect_fields: "Incorrect field, no numbers allowed",
      required_field: "Required Field",
      invalid_email: "Invalid Email"
    },
    attachments: {
      labels: {
        header: "Attachments"
      },
      first_details: "Please upload all required attachments",
      second_details: "to the application attachments section"
    },
    rules: {
      required_field: "Required field"
    }
  },
  regeneron: {
    generate_pdf_button: "Generate PDF",
    no_diagnosis_message:
      "This patient does not have an on-label diagnosis for Libtayo. Please add or update the diagnosis in 'Manage Patient Details' to continue enrollment."
  },
  caregiver: {
    title: "Parent/Guardian Information",
    subtitle: "Please provide information about the patient's parent or legal guardian.",
    first_name: "Related Person First Name",
    first_name_placeholder: "Enter first name",
    last_name: "Related Person Last Name",
    last_name_placeholder: "Enter last name",
    dob: "Related Person Date of Birth",
    relationship: "Relationship to Patient",
    relationship_placeholder: "Select relationship",
    phone: "Related Person Phone Number",
    phone_placeholder: "Enter phone number",
    additional_phone: "Additional Phone Number",
    additional_phone_placeholder: "Enter additional phone number",
    signed_authorization: "Signed Person Authorization",
    signed_authorization_placeholder: "Select authorization status",
    signed_yes: "Yes",
    signed_no: "No",
    relationship_caregiver: "Caregiver",
    relationship_parent: "Parent",
    relationship_family: "Family",
    relationship_spouse: "Spouse",
    relationship_partner: "Partner",
    relationship_friend: "Friend",
    relationship_child: "Child"
  },
  pfizer_sonnexus: {
    dummy: "dummy",
    info_notice:
      "<div>A valid prescription must be received before a determination of assistance can be made as this is a requirement for program enrollment. An e-signed enrollment form is <bold>not a valid prescription.</bold>  In order for your patient to be considered for assistance, <bold>a valid prescription is required and must be submitted at the time of enrollment request in one of two ways:</bold><br><br><bold>Option 1:</bold> Submit a paper prescription with an ink signature, either by faxing it to 1-877-736-6506 or by attaching a scanned copy to the application <br><br><bold>Option 2:</bold> E-prescribe to Sonexus Health Pharmacy Services (SHPS) (NPI number - 1447680210; NCPDP 5910206).  <bold>New York prescribers must e-prescribe.</bold></div>"
  },
  attestation_field: {
    default_text: "I attest that the above is true and correct.",
    required_message: "Should accept attestation"
  }
};
